import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";

import logoUx from "../assets/logoUxWhite.svg";
import backgroundHero from "../assets/icon-payment-fail.svg";

import {
  ButtonEntry,
  Container,
  DescriptionLabel,
  Heading,
  LeftWrapper,
  MainContainer,
  RightWrapper,
  Text,
  ButtonCreateNewAccount,
  VerticalStack
} from "./styles";

import DecorationBackground from "../../register/screen/DecorationBackground";
import IconSvg from "../../editor/components/IconSvg";
import api from "../../../services/api";
import { getStripeJs } from "../../../services/stipe-js";

const SuspendedView: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubscription = useCallback(async () => {
    try {
      const response = await api.post("stripe/create-session-payment");
      const { session_id } = response.data;
      const stripe = await getStripeJs();
      await stripe?.redirectToCheckout({ sessionId: session_id });
      setLoading(false);
    } catch (err) {
      console.log(err, "error!!!!");
      alert(err.message);
    }
  }, []);

  return (
    <Container>
      <ToastContainer />
      <LeftWrapper>
        <DecorationBackground />
        <MainContainer>
          <IconSvg
            className="logo-uxdoc-register"
            src={logoUx}
            description=""
          />

          <img src={backgroundHero} className="background-image" />
        </MainContainer>
      </LeftWrapper>
      <RightWrapper>
        <VerticalStack>
          <Heading>
            Ops... parece que houve algum problema com o seu pagamento
          </Heading>
          <Text>
            Mas não se preocupe. <br /> Clique no botão abaixo para renovar sua
            assinatura ou alterar o meio de pagamento e volta a criar
            documentos. É rapidinho!
          </Text>
          {/* <span className="span-text">
            Renove a sua assinatura e volte a criar os seus documentos, é
            rapidinho!
          </span> */}
          <ButtonCreateNewAccount onClick={handleSubscription}>
            Ir para a área de pagamento
          </ButtonCreateNewAccount>
        </VerticalStack>
      </RightWrapper>
    </Container>
  );
};

export default SuspendedView;
